export default "__VITE_ASSET__afc9ee48__"